import React, { useState } from 'react';
import { login } from '../../api/auth';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login({ username, password });
      onLogin(res.data);
    } catch (err) {
      setError(err.response?.data?.msg || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo.png" alt="" className="login-logo-img" />
          <span className="login-logo-text">KSEPro</span>
        </div>
        <p className="login-subtitle">KS Elektro Project Manager</p>
        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">Username</label>
          <input className="login-input" type="text" value={username}
            onChange={(e) => setUsername(e.target.value)} autoFocus required />
          <label className="login-label">Password</label>
          <input className="login-input" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
          {error && <p className="login-error">{error}</p>}
          <button className="btn-primary login-submit" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
